<template>
  <el-dialog :visible='visible' :title="$t('Batch_Access')" @close="close" >
    <p class="label">{{$t("TABLE_HEADER_Access_Level")}}</p>
    <MemberAccessLevelSelect class="mb_20" :initData="accessType"  @change="getAccessTypeValue"/>
    <p class="label">{{$t("MEMBER_TABLE_HEADER_CLIENT_ENTITIES")}}</p>
    <el-select  v-if="!accessType" style="width:100%" value=""></el-select>
     <el-select class="mb_20" v-else-if="accessType ==='ALL'" style="width:100%" disabled :value="$t('All_ENTITIES')"></el-select>
    
      <select-tree v-else class="mb_20"  :data="data" style="width:100%" :filterable="true" :check-strictly="true"  
          @visible-change="handleVisibleChange" :defaultCheckedKeys="defaultCheckedKeys"
          :defaultExpandAll="true" :defaultProps="defaultProps" >
      </select-tree>

    <footer  slot="footer">
      
      <el-button  class="btn-cancel" @click="close">
        {{ $t("btn_cancel") }}
      </el-button>
      
      <el-button type="primary" @click="submit">
        {{ $t("btn_confirm") }}
      </el-button>
    </footer>
  </el-dialog>
</template>

<script>
import MemberAccessLevelSelect from "../memberAccessLevelSelect.vue"
import selectTree from "../selectTree.vue"

export default {
    components:{MemberAccessLevelSelect,selectTree},
    props:{
        visible:{
            type: Boolean,
            default:false,
        },
        data:{
            type:Array,
            default:()=>[]
        },
        allNodes:{
            type:Array,
            default:()=>[]
        },
        roleList:{
            type:Array,
            default:()=>[]
        }
    },
    data(){
        return {
            accessType:null,
            roleIdList:[],
             defaultProps: {
                children: 'childEntity',
                label: 'entityName'
            },
            defaultCheckedKeys:[],
        }
    },
    methods:{
        getAccessTypeValue(val){
            this.accessType =val;
            this.allNodes.forEach(e=>e.checked =false)
            if(val ==='ALL')  this.clientEntityIds =[]
        },
          handleVisibleChange(list) {
           if(list.length===this.allNodes.length&&this.accessType==='SPECIFIC'){
                this.$confirm(this.$t("ROLE_CHANGE_TIP"), this.$t('COMMON_TIP'), {
                confirmButtonText: this.$t('btn_confirm'),
                cancelButtonText: this.$t('btn_cancel'),
                type: 'warning'
                }).then(()=>{
                    this.accessType = "ALL";
                    this.clientEntityIds =[]
                    return 
                }).catch(action=>{
                    if(action ==='cancel'){
                      this.defaultCheckedKeys =[];
                      this.allNodes.forEach(e=>e.checked =false)
                    }
                })
               return
            }
        this.clientEntityIds = list.map(v=>v.id);
      },
        submit(){
          this.$emit("submit",{clientEntityIds:this.clientEntityIds,accessType:this.accessType,roleIdList:this.roleIdList})
        },
        close(){
          this.accessType="";
          this.data={};
          this.roleIdList =[];

            this.$emit("close")
        }
    }

}
</script>

<style  scoped>
.mb_20{
    margin-bottom: 20px;
}
.label {
   margin-bottom:10px;
}
 ::v-deep .el-dialog{
    width: 600px;
 }
</style>>

